export default {
      id: "custom-routes-usage",
      viewBox: "0 0 78 62",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#custom-routes",
      toString: function () {
        return this.url;
      }
    }